import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { FaqHelpEventProvider } from './domain/events/faq-help/faq-help-event_provider';
import { MessageHelpEventProvider } from './domain/events/message-help/message-help-event_provider';
import { FaqHelpRepository } from './repositories/faq-help_repository';
import { MessageHelpRepository } from './repositories/message-help_repository';
import { UrlTargetingRepository } from './repositories/url-targeting_repository';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [FaqHelpRepository, MessageHelpRepository, UrlTargetingRepository],
})
export class HelpMeModule {
  static forRoot(): ModuleWithProviders<HelpMeModule> {
    return {
      ngModule: HelpMeModule,
      providers: [
        {
          provide: MessageHelpEventProvider,
        },
        {
          provide: FaqHelpEventProvider,
        },
      ],
    };
  }
}
